import script from "./unrecive-insurance-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./unrecive-insurance-list.vue?vue&type=script&lang=ts&setup=true"

import "./unrecive-insurance-list.vue?vue&type=style&index=0&id=c1beed56&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1beed56"]])

export default __exports__